import React from 'react';

export interface PhaseLike {
  pattern: number;
  intensity: number;
  length: number;
}

const MAX_INTENSITY = 100;
const MAX_LENGTH = 30; // minutes — matches the phase length cap enforced in CreateSequence

const PhaseBars: React.FC<{
  phases: PhaseLike[];
  height?: number;
}> = ({ phases, height = 56 }) => (
  <div className="flex items-end gap-1" style={{ height }}>
    {phases.map((phase, i) => {
      const active = phase.intensity > 0 && phase.length > 0;
      const barHeight = active ? Math.max(6, Math.round((phase.intensity / MAX_INTENSITY) * height)) : 4;
      const barWidth = active ? 8 + Math.round((phase.length / MAX_LENGTH) * 24) : 8;
      return (
        <div
          key={i}
          title={active ? `Phase ${i + 1}: ${phase.intensity}% intensity, ${phase.length} min` : `Phase ${i + 1}: off`}
          className={`rounded-sm transition-all ${active ? 'bg-MyovoltPurple' : 'bg-gray-200'}`}
          style={{ height: barHeight, width: barWidth }}
        />
      );
    })}
  </div>
);

export default PhaseBars;
